import { IMG, STUDIO_IMAGES } from './lib/images';
import { companies } from './data/companyPages';

export const navLinks = [
  {
    label: 'About',
    children: [
      { label: 'About InnovHer', to: '/about', note: 'Vision & Ecosystem' },
      { label: 'The Team', to: '/about/team', note: 'Leadership & Advisors' },
      { label: 'The Network', to: '/about/network', note: 'Partners & Ecosystem' },
    ],
  },
  {
    label: 'Ventures',
    children: companies
      .filter((c) => c.slug !== 'innovz')
      .map((c) => ({
        label: c.navLabel,
        to: `/ventures/${c.slug}`,
      })),
  },
  { label: 'InnovAce', to: '/innovace' },
  {
    label: 'Infrastructure',
    children: [
      { label: 'Studio-I', to: '/studio-i' },
      { label: 'InnovPulse', to: '/innovpulse' },
      // Near-future: uncomment when ready to show on main site
      // { label: 'InnovZ', to: '/innovz' },
    ],
  },
  // Near-future: { label: 'InnovVeda', to: '/innoveda' },
  { label: 'iSSi', to: '/issi' },
  { label: 'Footprint', to: '/footprint' },
  { label: 'Build With Us', to: '/contact' },
];

/** Destinations for the navbar Apply CTA dropdown */
export const applyMenuItems = [
  { label: 'InnovAce', to: '/apply', note: 'Accelerator application form' },
  { label: 'Login', to: '/login', note: 'Accelerator portal login' },
];

export const CONTACT = {
  email: 'info@innovher.com',
  whatsapp: '+917891502909',
  phone: '+91 78915 02909',
  address: 'Jaipur, Rajasthan · India',
  socials: {
    linkedin: 'https://www.linkedin.com/company/innovher.com/',
    facebook: 'https://www.facebook.com/profile.php?id=61551582736876',
    twitter: 'https://twitter.com/innovher',
    instagram: 'https://www.instagram.com/innovher/',
    youtube: 'https://www.youtube.com/@innovher',
  },
};

export const stats = [
  { value: 21, suffix: '', label: 'Ventures in Portfolio (16 Alumni + 5 Active)' },
  { value: 20, suffix: 'cr.+', label: 'Co-investments facilitated' },
  { value: 80, suffix: 'cr.+', label: 'Revenue generated by ventures' },
  { value: 81, suffix: 'cr.', label: 'Portfolio valuation' },
  { value: 398, suffix: '+', label: 'High-value jobs created' },
  { value: 64, suffix: '+', label: 'National mentors & operators' },
  { value: 102, suffix: '+', label: 'Founders actively supported' },
  { value: 5, suffix: '', label: 'Ventures actively being built' },
];

export const services = [
  { title: 'Strategic Thinking & Growth Mapping', desc: 'Business Modelling, Financial MIS, Projections & Cash Flow. Backed by expert Financial Advisory.', icon: 'Target' },
  { title: 'Research & Market Analytics', desc: 'Sector Analysis, Competitor Mapping, Brand Development. Driven by our GTM Strategies.', icon: 'TrendingUp' },
  { title: 'Adaptability, Resilience & Growth', desc: 'Lean Management, Sustainability & Impact, Expansion & Structuring. Focused on Innovation Integration.', icon: 'GraduationCap' },
  { title: 'Negotiations, Communication & Network', desc: 'Pitch Deck, Business Collaterals, Marketing & Sales, Strategic Collaborations through our Business Network.', icon: 'Users' },
];

// 02, WHAT WE DO: Building Capabilities
export const buildingCapabilities = [
  {
    id: 'innovventures',
    brand: 'InnovVentures',
    tagline: 'From possibility to enterprise',
    desc: 'The venture studio arm, where opportunities are identified, concepts are shaped and new businesses are built, hands-on from within.',
    focus: [
      'Venture strategy & product',
      'Business models & validation',
      'Partnerships, technology & GTM',
      'Build alongside founders & partners',
    ],
    badge: 'Venture Studio',
    icon: 'Layers',
  },
  {
    id: 'innovace',
    brand: 'InnovAce',
    tagline: 'Accelerating ambition into scale',
    desc: 'An intensive 18-month accelerator for founders and ventures ready to move from potential to measurable growth.',
    focus: [
      'Strategic guidance & founder capability',
      'Market access & mentorship',
      'Investment readiness',
      'Capital & collaboration',
    ],
    badge: 'Accelerator',
    icon: 'Workflow',
  },
  {
    id: 'innovidea',
    href: '/innovidea',
    brand: 'InnovIdea',
    tagline: 'Ideas deserve an identity powerful enough to travel',
    desc: 'Brand, communication and growth practice, transforming business ideas into brands that can be understood, experienced and remembered.',
    focus: [
      'Positioning & identity',
      'Storytelling & digital presence',
      'Campaigns & market communication',
      'Perception, trust and relevance',
    ],
    badge: 'Brand & Growth',
    icon: 'Compass',
  },
  {
    id: 'innoveda-ai',
    brand: 'InnovVeda.ai',
    tagline: 'Technology to scale and expand horizons',
    desc: 'Technology and AI development team, translating business ideas into intelligent, scalable digital products and infrastructure.',
    focus: [
      'Product architecture & platforms',
      'AI integration & automation',
      'Data systems',
      'Business-outcome led technology',
    ],
    badge: 'Technology & AI',
    icon: 'Cpu',
  },
];

// 03, WHAT WE'RE BUILDING: Current Ventures
export const venturesBeingBuilt = [
  {
    name: 'EnCODE',
    slug: 'encode',
    category: 'Future of Work',
    stage: 'Active Build · Scaling',
    tagline: 'Capability for the future of work',
    desc: 'Building capability for the future of work and creative industries.',
    highlights: ['Personalised AI learning pathways', 'Live industry capstone projects', 'Direct career & apprenticeship pipeline', 'Phygital ecosystem model'],
    logo: '/new_images/logos/encode.webp',
    logoText: 'enCODE',
    accentColor: '#38bdf8',
  },
  {
    name: 'Ctpl.Online',
    slug: 'ctpl',
    category: 'Higher Ed Infrastructure',
    stage: 'Active Build · Scaling',
    tagline: 'Enterprise layer for online higher ed',
    desc: 'Building the enterprise layer for online higher education.',
    highlights: ['Admissions management engine', 'AI-enabled assessments platform', 'Student Relationship Management (SRM)', 'Scalable institutional workflows'],
    logo: '/new_images/logos/ctpl.online.webp',
    logoText: 'CTPL',
    accentColor: '#a855f7',
  },
  {
    name: 'BaX',
    slug: 'beyond-ability-x',
    category: 'Inclusive Sports Tech',
    stage: 'Active Build · Expansion',
    tagline: "India's inclusive sports economy",
    desc: "Building India's inclusive sports economy.",
    highlights: ['Athlete Passport identity system', 'Professional sporting opportunities', 'Dedicated sports storytelling & media', 'Ecosystem & institutional partnerships'],
    logo: '/new_images/logos/Beyond Ability X Logo_Purple.webp',
    logoText: 'BA-X',
    accentColor: '#ec4899',
  },
  {
    name: 'i2i connect',
    slug: 'i2i',
    category: 'Idea to Impact',
    stage: 'Active Build · Incubation',
    tagline: 'IP to commercial ventures',
    desc: 'Turning innovation and intellectual property into scalable commercial ventures.',
    highlights: ['Rapid prototyping & validation', 'Commercial viability frameworks', 'Go-to-market testing', 'Impact-led venture architecture'],
    logo: '/new_images/logos/I2I.webp',
    logoText: 'i2i',
    accentColor: '#10b981',
  },
];

// 04, VENTURE INFRASTRUCTURE: Operational Backbone
export const ventureInfrastructure = [
  {
    id: 'studio-i',
    name: 'Studio-I',
    type: 'The Physical Layer',
    tagline: 'Where ideas, people and businesses come together',
    desc: 'Innovher’s collaborative workspace and startup ecosystem hub for founders, professionals, mentors, investors and growing teams.',
    metrics: ['Work', 'Connect', 'Collaborate', 'Grow'],
    href: '/studio-i',
  },
  {
    id: 'innovpulse',
    name: 'InnovPulse',
    type: 'The Intelligence Layer',
    tagline: 'Operating & performance system',
    desc: 'An integrated operating and performance system connecting organisational priorities, ownership, execution and performance.',
    metrics: ['Priority clarity', 'Execution tracking', 'Organisational visibility'],
    href: '/innovpulse',
  },
  // {
  //   id: 'innovz',
  //   href: '/innovz',
  //   name: 'InnovZ',
  //   type: 'The Leadership & Talent Layer',
  //   tagline: 'From inheriting enterprise to imagining what comes next',
  //   desc: 'A six-month immersive experience introducing the next generation of business families to startups, innovation and venture investing.',
  //   metrics: ['6-month immersion', 'Gen Z', 'Venture exposure', 'Investor mindset'],
  // },
  {
    id: 'issi',
    name: 'iSSi',
    type: 'InnovHer Startup Support Initiative',
    tagline: 'Because innovation needs a society that shows up',
    desc: 'Nurturing the environment around entrepreneurship through recurring formats, open conversations and curated experiences.',
    metrics: ["Founders' Night", 'Enablers Engage', 'Fish Tank'],
    href: '/issi',
  },
];

// 06, HOW WE THINK: Venture Thesis
export const ventureThesis = {
  quote: 'Build with intent. Scale with evidence.',
  manifesto: [
    {
      number: '01',
      title: 'Validate Before Expanding',
      text: 'Test the market, customer and business model before committing to scale.',
    },
    {
      number: '02',
      title: 'Build Before Fundraising',
      text: 'Strengthen product, systems, economics and execution before pursuing capital.',
    },
    {
      number: '03',
      title: 'Measure Before Scaling',
      text: 'Use data, traction and operating evidence to guide growth decisions.',
    },
    {
      number: '04',
      title: 'Scale With Discipline',
      text: 'Deploy capital, talent and partnerships where they create measurable value.',
    },
  ],
};

// 07, BUILD WITH US: Persona Pathways
export const buildWithUsPathways = [
  { id: 'founders', title: 'Founders', tagline: 'Build or accelerate your venture', benefits: [], cta: 'Build with Us' },
  { id: 'businesses', title: 'Businesses', tagline: 'Build a new venture, product or growth engine', benefits: [], cta: 'Partner with Us' },
  { id: 'investors', title: 'Investors', tagline: 'Access ventures and opportunities', benefits: [], cta: 'Explore Dealflow' },
  { id: 'institutions', title: 'Institutions', tagline: 'Build entrepreneurship and innovation programmes', benefits: [], cta: 'Collaborate' },
  { id: 'talent', title: 'Talent', tagline: 'Build with our ventures', benefits: [], cta: 'Join the Build' },
];

export const sectors = [
  { key: 'luxury', slug: 'luxury-lifestyle', title: 'Luxury & Lifestyle', tagline: 'Crafting brands that define modern indulgence.', desc: 'Curated investments and growth playbooks for luxury, fashion, beauty and premium lifestyle ventures rooted in heritage and design.', image: IMG.luxury1, image2: IMG.luxury2, highlights: ['Heritage-led brand storytelling', 'Premium positioning & D2C playbooks', 'Designer mentor circle', 'Retail & marketplace distribution'] },
  { key: 'industry5', slug: 'industry-5-0', title: 'Industry 5.0', tagline: 'Backing the next layer of technology & the internet.', desc: 'Pioneering everything related to tech, including Web 3.0, AI, deep-tech, and consumer-tech ventures building category-defining products with global ambition.', image: IMG.newtech1, image2: IMG.newtech2, highlights: ['Web 3.0 & emerging tech', 'AI & applied ML', 'Deep-tech & SaaS', 'Founder-led tech velocity'] },
  { key: 'impact', slug: 'impact', title: 'Impact', tagline: 'Capital that moves the needle.', desc: 'Climate, education, healthcare and livelihoods, ventures driving measurable social impact alongside commercial returns.', image: IMG.impact1, image2: IMG.impact2, highlights: ['Climate & sustainability', 'EdTech & livelihoods', 'Affordable healthcare', 'Women-led & rural ventures'] },
];

export const process = [
  { n: '01', t: 'Discover', d: 'We meet ambitious founders solving real problems with category-defining products.' },
  { n: '02', t: 'Diagnose', d: 'A structured 360° venture diagnostic across product, GTM, team and capital.' },
  { n: '03', t: 'Design', d: 'A custom acceleration roadmap with weekly milestones and mentor sprints.' },
  { n: '05', t: 'Scale', d: 'From 1 to 10, with continuous strategic support, board access and follow-on rounds.' },
];

// Real Innovher leadership (About page)
export const team = [
  {
    id: 'shweta-choudhary',
    initials: 'SC',
    name: 'Dr. Shweta Choudhary',
    designation: 'Founder & Director',
    category: 'Leadership',
    image: '/shweta22.webp',
    fallbackInitials: 'SC',
    linkedin: 'https://www.linkedin.com/in/dr-shweta-choudhary/',
    intro: 'Vision-bearer of InnovHer. Building an institution for venture building where founders meet capability and capital meets readiness.',
  },
  {
    id: 'digvijay-singh',
    initials: 'DS',
    name: 'Digvijay Singh',
    designation: 'Director & CTO',
    category: 'Leadership',
    image: '/digvijay.webp',
    fallbackInitials: 'DS',
    linkedin: 'https://www.linkedin.com/in/digvijay-singh-70104213b/',
    intro: 'Architecting InnovHer’s proprietary technology infrastructure, venture intelligence stack, and digital products.',
  },
  {
    id: 'onkar-bagaria',
    initials: 'OB',
    name: 'Onkar Bagaria',
    designation: 'Strategic Partner',
    category: 'Leadership',
    image: '/team/omkarsir.jpeg',
    fallbackInitials: 'OB',
    linkedin: 'https://www.linkedin.com/in/onkar-bagaria/',
    intro: 'CEO at VGU, championing academic innovation corridors, incubation ecosystems, and entrepreneurial education.',
  },
  {
    id: 'jeet-vijay',
    initials: 'JV',
    name: 'Jeet Vijay',
    designation: 'Lead : Bharat Ventures / Advisory Board',
    category: 'Leadership',
    image: '/team/ajeet.jpeg',
    fallbackInitials: 'JV',
    linkedin: 'https://www.linkedin.com/in/jeetvijay/',
    intro: 'Former CEO of MeitY Startup Hub; national venture ecosystem leader catalyzing high-impact startups and grassroots innovation.',
  },
  {
    id: 'shivam-sharma',
    initials: 'SS',
    name: 'Shivam Sharma',
    designation: 'Lead : Bharat XLR8AR',
    category: 'Leadership',
    image: '/shivam.webp',
    fallbackInitials: 'SS',
    linkedin: 'https://www.linkedin.com/in/shivam-sharma-6832621a9/',
    intro: 'Venture acceleration lead turning early traction into scalable business playbooks and investor-ready commercial models.',
  },
  {
    id: 'raman-poonia',
    initials: 'RP',
    name: 'Raman Poonia',
    designation: "Founder's Office",
    category: 'Core Team',
    image: '/team/raman-poonia.webp',
    fallbackInitials: 'RP',
    linkedin: '',
    intro: 'Driving strategic initiatives, founder operations, and cross-functional execution at InnovHer.',
  },
  {
    id: 'utkarsh-jain',
    initials: 'UJ',
    name: 'Utkarsh Jain',
    designation: 'Invested Analyst',
    category: 'Core Team',
    image: '/team/utkarsh-jain.jpg',
    fallbackInitials: 'UJ',
    linkedin: '',
    intro: 'Venture evaluation, portfolio support, and investment analysis across early-stage startups and ecosystems.',
  },
  {
    id: 'milap-jadeja',
    initials: 'MJ',
    name: 'Milap Jadeja',
    designation: 'Strategic Advisor & Angel Investor',
    category: 'Strategic Partner',
    image: '/team/pay-tamasha.webp',
    fallbackInitials: 'MJ',
    linkedin: 'https://share.google/lA8a6NqPHi1NbiTMj',
    intro: 'Strategic investor, venture advisor, and ecosystem builder supporting transformative early-stage businesses.',
  },
  {
    id: 'ajay-data',
    initials: 'AD',
    name: 'Ajay Data',
    designation: 'Strategic Advisor & Angel Investor',
    category: 'Strategic Partner',
    image: '/team/ajay-data.webp',
    fallbackInitials: 'AD',
    linkedin: 'https://in.linkedin.com/in/ajaykdata',
    intro: 'Founder & MD of Data Group, TiE Global Trustee and veteran angel investor connecting regional ventures to national and global investment syndicates.',
  },
  {
    id: 'aditya-malik',
    initials: 'AM',
    name: 'Aditya Malik',
    designation: 'Venture Operations & Growth',
    category: 'Strategic Partner',
    image: '/team/aditya-malik.webp',
    fallbackInitials: 'AM',
    linkedin: 'https://share.google/f3lJgAHXZ611OG05S',
    intro: 'Venture growth strategist driving early execution, business collaborations, and operational scale.',
  },
  {
    id: 'mandar-joshi',
    initials: 'MJ',
    name: 'Mandar Joshi',
    designation: 'Strategic Advisor & Angel Investor',
    category: 'Strategic Partner',
    image: '/team/madnar-main.webp',
    fallbackInitials: 'MJ',
    linkedin: 'https://www.linkedin.com/in/mahavirsharma/',
    intro: 'Angel investor, venture mentor, and ecosystem catalyst guiding high-growth startups across technology and market access.',
  },
  {
    id: 'harshit-soni',
    initials: 'HS',
    name: 'Harshit Soni',
    designation: 'Finance Head',
    category: 'Strategic Partner',
    image: '/team/harshit-soni.webp',
    fallbackInitials: 'HS',
    linkedin: 'https://in.linkedin.com/in/ca-harshittsoni5',
    intro: 'Chartered accountant leading financial structuring, venture compliance, governance frameworks, and fiscal advisory.',
  },
  {
    id: 'vijetha-shastry',
    initials: 'VS',
    name: 'Vijetha Shastry',
    designation: 'Strategic Advisor & Ecosystem Leader',
    category: 'Strategic Partner',
    image: '/team/vijetha.webp',
    fallbackInitials: 'VS',
    linkedin: 'https://www.linkedin.com/in/vijethashastry/',
    intro: 'Venture ecosystem builder and seasoned startup strategist connecting founders with institutional networks, capital, and open innovation pathways.',
  },
  {
    id: 'amit-singhal',
    initials: 'AS',
    name: 'Amit Singhal',
    designation: 'Strategic Advisor & Founding Partner, Fluid Ventures',
    category: 'Strategic Partner',
    image: '/team/Amit-main.webp',
    fallbackInitials: 'AS',
    linkedin: 'https://www.linkedin.com/in/amit-singhal-ca/',
    intro: 'Venture capitalist backing tech-led consumer and direct-to-consumer ventures with seed capital, governance frameworks, and strategic scale.',
  },
  {
    id: 'vijay-choudhary',
    initials: 'VC',
    name: 'Vijay Choudhary',
    designation: 'Advisory Board Member & Growth Strategist',
    category: 'Strategic Partner',
    image: '/team/vijay.webp',
    fallbackInitials: 'VC',
    linkedin: 'https://www.linkedin.com/in/vijay-choudhary/',
    intro: 'Enterprise mentor and growth strategist helping ventures accelerate corporate partnerships, operations, and market access.',
  },
  {
    id: 'surya-tripathi',
    initials: 'ST',
    name: 'Surya Tripathi',
    designation: 'Venture Partner & Technology Strategist',
    category: 'Strategic Partner',
    image: '/team/surya.webp',
    fallbackInitials: 'ST',
    linkedin: 'https://www.linkedin.com/in/surya-tripathi/',
    intro: 'Deep-tech architect and product strategist guiding early ventures in software architecture, scalable infrastructure, and AI engineering.',
  },
  {
    id: 'harsha-ramnani',
    initials: 'HR',
    name: 'Harsha Ramnani',
    designation: 'Programs & Cohort Operations Lead',
    category: 'Strategic Partner',
    image: '/team/harsha.webp',
    fallbackInitials: 'HR',
    linkedin: 'https://www.linkedin.com/in/harsha-ramnani/',
    intro: 'Leading founder cohort experiences, venture acceleration modules, and cross-ecosystem collaborations for InnovHer platforms.',
  },
  {
    id: 'umang-maheshwari',
    initials: 'UM',
    name: 'Umang Maheshwari',
    designation: 'Lead - Venture Operations & Investments',
    category: 'Strategic Partner',
    image: '/team/umang1.jpg',
    fallbackInitials: 'UM',
    linkedin: 'https://www.linkedin.com/in/umangmaheshwari/',
    intro: 'Entrepreneur and venture operator managing pipeline evaluation, founder support, capital mobilization, and portfolio synergy.',
  },
];

export const advisors = [
  { name: 'Jeet Vijay', role: 'Lead : Bharat Ventures', image: IMG.advJeet, linkedin: 'https://www.linkedin.com/in/jeetvijay/' },
  { name: 'Digvijay Singh', role: 'Director', image: IMG.digvijayProfile, linkedin: 'https://www.linkedin.com/in/digvijay-singh-70104213b/' },
  { name: 'Shivam Sharma', role: 'Lead : Bharat XLR8AR', image: IMG.advShivam, linkedin: 'https://www.linkedin.com/in/shivam-sharma-6832621a9/' },
  { name: 'Onkar Bagaria', role: 'Strategic Partner', image: IMG.advOnkar, linkedin: '#' },
];

export const mentors = [
  { name: 'Alka Batra', role: 'Women Founder & Panelist', tag: 'Luxury' },
  { name: 'Rimi Shekhawat', role: 'Founder & Panelist', tag: 'Hospitality' },
  { name: 'Raghushree Poddar', role: 'Founder & Panelist', tag: 'NewTech' },
  { name: 'Dr. Pooja Aggarwal', role: 'Leader & Panelist', tag: 'Impact' },
  { name: 'Shweta Singh', role: 'Leader & Panelist', tag: 'NewTech' },
  { name: 'Pushpa Mai', role: 'Ecosystem Voice', tag: 'Impact' },
  { name: 'Surashree Rahane', role: 'Ecosystem Voice', tag: 'NewTech' },
  { name: 'Dishank Sharma', role: 'Team Innovher', tag: 'Luxury' },
];

export const values = [
  { t: 'Inclusivity by design', d: 'Equity isn’t a checkbox, it’s a multiplier for innovation.' },
  { t: 'Founder-first', d: 'We optimise for the long game and the founder’s sanity.' },
  { t: 'Process over hype', d: 'Repeatable playbooks beat one-off heroics.' },
  { t: 'Ecosystem > ego', d: 'We win by making the room bigger.' },
];

export const stories = [
  { slug: 'founder-words', tag: 'Founder’s Note', title: 'The story behind Innovher', desc: 'Why we believe the next decade of Indian innovation will be inclusive, founder-first and built from tier-2 cities.', date: 'Jan 23, 2024', image: IMG.innovherFounder, to: '/founders-note' },
  { slug: 'first-portfolio', tag: 'Event', title: 'First Portfolio Showcase, Jaipur', desc: 'Networking made easy for entrepreneurs and investors at our flagship showcase event.', date: 'Mar 12, 2024', image: IMG.innovherFirstPortfolio, to: '/stories/first-portfolio' },
  { slug: 'medi-innovate', tag: 'Program', title: 'MEDI-INNOVATE', desc: 'Founders, mentors and investors converge to accelerate medical innovation across India.', date: 'May 04, 2024', image: IMG.innovherMedi, to: '/stories/medi-innovate' },
  { slug: 'launching-event', tag: 'Launch', title: 'Innovher Launch, 5th Nov 2023', desc: 'India’s first founder-centric startup accelerator goes live, from the pink city.', date: 'Nov 05, 2023', image: IMG.innovherLaunch, to: '/stories/launching-event' },
  { slug: 'd2c-news', tag: 'Press', title: 'Innovher in the news', desc: 'Covered by top media publications across business and innovation desks.', date: 'Jul 18, 2024', image: IMG.innovherNews, to: '/stories/d2c-news' },
  { slug: 'd2c-report', tag: 'Insight', title: 'D2C innovation report', desc: 'A deep dive into emerging direct-to-consumer plays from our portfolio and beyond.', date: 'Sep 22, 2024', image: IMG.innovherFirstPortfolio, to: '/stories/d2c-report' },
];

// Long-form content for individual stories
export const storyPosts = {
  'launching-event': {
    tag: 'Launch · Nov 5, 2023',
    title: 'Unleashing the Power of Diversity: Innovher’s Inspirational Journey',
    summary: 'The inauguration ceremony at the Rajasthan Innovation Center marked the launch of Innovher, a groundbreaking initiative focused on promoting and supporting Women, LGBTQ+, and Specially Abled Founders in the startup ecosystem.',
    image: IMG.innovherLaunch,
    body: [
      'Step into a world where innovation knows no boundaries. At Innovher, we believe that diversity is the wellspring of innovation. We are proud to showcase our relentless commitment to accelerating the LGBTQ+ community and disabled women, while paving the way for aspiring entrepreneurs to achieve their dreams.',
      'The inauguration ceremony drew the attention of prominent figures in the startup world who gathered to discuss the state of the startup landscape, particularly addressing the question, “Startup Ecosystem: An Equal Playground or Still a Man’s World?” The panel featured accomplished women founders and leaders, including Alka Batra, Rimi Shekhawat, Raghushree Poddar, Dr. Pooja Aggarwal, and Shweta Singh, who shared valuable insights and perspectives on the challenges faced by underrepresented entrepreneurs.',
      'The discussions shed light on aspects often overlooked, with participants like Pushpa Mai, Chandan Verma, Surashree Rahane, and Anamika Joshi contributing their unique experiences. The overarching theme emphasized the importance of creating an inclusive and supportive ecosystem that empowers underrepresented entrepreneurs.',
      'Dr. Shweta Choudhary, the Founder Director of Innovher, expressed the initiative’s mission to provide guidance, mentorship, investment, and networking opportunities to support these founders. Digvijay Singh, CTO of Innovher, outlined a vision that goes beyond a traditional startup accelerator, positioning Innovher as a movement that aims to foster collaboration and innovation.',
      'The initiative has set an ambitious target of providing over ₹10 crore in funds through investments and grants to eligible startups in the next year, signaling a strong commitment to supporting the growth of startups in the region.',
      'The strength of the Innovher campaign lies in its team, with mentor Sushil Sharma, CEO of Marwari Catalysts, bringing valuable experience to the Innovher portfolio. The team, comprising individuals like Nikhil Gupta and Dishank Sharma, adds a dynamic element with their own startup experiences, making Team Innovher a formidable force.',
    ],
    tags: ['lifestyle', 'lgbtq', 'business'],
  },
  'first-portfolio': {
    tag: 'Event · Mar 12, 2024',
    title: 'Innovher Hosts Its First Portfolio Showcase Event in Jaipur',
    summary: 'A flagship showcase of the inaugural Innovher cohort, bringing founders, investors, mentors and ecosystem partners together in the pink city.',
    image: IMG.innovherFirstPortfolio,
    body: [
      'On a buzzing evening in Jaipur, the Innovher portfolio took centre stage at our first-ever showcase event. Founders pitched live to a curated audience of investors, corporate partners and mentors, with structured 1:1 break-outs designed to make networking actually useful.',
      'From luxury and hospitality to new-tech and impact, every venture brought a different lens on what the next decade of inclusive Indian innovation looks like. The energy in the room confirmed what we’ve believed since day one, when you back great founders with great rooms, outcomes follow.',
      'A big thank you to every founder, mentor, investor and partner who showed up. The next showcase is already in the works.',
    ],
    tags: ['portfolio', 'event', 'jaipur'],
  },
  'medi-innovate': {
    tag: 'Program · May 4, 2024',
    title: 'MEDI-INNOVATE, Accelerating Medical Innovation in India',
    summary: 'Founders, mentors and investors converge to accelerate the next generation of medical and healthcare ventures across India.',
    image: IMG.innovherMedi,
    body: [
      'MEDI-INNOVATE is Innovher’s focused thematic program for healthcare and medical innovation. The program brings together clinician-founders, deep-tech medical startups and impact investors to fast-track ventures tackling India’s most pressing health challenges.',
      'Across the cohort, we focus on regulatory readiness, clinical validation pathways, capital efficiency, and distribution into Tier-2 / Tier-3 markets where impact is the highest.',
      'Applications for the next cohort are open. If you’re building in diagnostics, women’s health, mental health, accessible care or medical devices, we want to meet you.',
    ],
    tags: ['healthcare', 'program', 'innovation'],
  },
  'd2c-news': {
    tag: 'Press · Jul 18, 2024',
    title: 'Innovher in the News',
    summary: 'Covered by top media publications across business, innovation and women-in-tech desks.',
    image: IMG.innovherNews,
    body: [
      'Innovher has been featured across India’s top business and innovation publications, a recognition of the work our founders are doing every single day.',
      'From the launch event to portfolio milestones, we’re thrilled to see the conversation around inclusive innovation enter the mainstream. Every story is a step closer to the future we’re building.',
      'Press enquiries: info@innovher.com',
    ],
    tags: ['press', 'media', 'recognition'],
  },
  'd2c-report': {
    tag: 'Insight · Sep 22, 2024',
    title: 'D2C Innovation Report 2024',
    summary: 'A deep dive into emerging direct-to-consumer plays, from our portfolio and the wider Indian ecosystem.',
    image: IMG.innovherFirstPortfolio,
    body: [
      'Indian D2C is entering its second wave, leaner, more profitable, and category-led. In this annual deep dive we look at what’s working, what isn’t, and where the next billion-rupee D2C brands are emerging from.',
      'Sections include, the great profitability reset, the rise of regional D2C, content-as-distribution, and what investors are looking for in a Series A pitch in 2024.',
      'Download the report or request a custom briefing for your team.',
    ],
    tags: ['d2c', 'insight', 'report'],
  },
};
